import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=f8921f4e&scoped=true&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"
import style0 from "./pie.vue?vue&type=style&index=0&id=f8921f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8921f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8921f4e')) {
      api.createRecord('f8921f4e', component.options)
    } else {
      api.reload('f8921f4e', component.options)
    }
    module.hot.accept("./pie.vue?vue&type=template&id=f8921f4e&scoped=true&", function () {
      api.rerender('f8921f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/pie.vue"
export default component.exports